import { Form } from '@genesislcap/foundation-forms';
import { html, ref, when } from '@microsoft/fast-element';
import { List } from '../list';
List;
Form;
/**
 * Default header for Entity Management screen
 * @internal
 */
const defaultHeader = html `
  <h3>${(x) => x.title}</h3>
  ${when((x) => x.createEvent, html `
      <zero-button appearance="neutral" @click=${(x, y) => x.createEntity()}>
        <zero-icon size="lg" name="plus"></zero-icon>
        Add
      </zero-button>
    `)}
`;
/**
 * Defines the html of the entity component as a ViewTemplate object
 * @typeParam EntityManagement - the {@link EntityManagement | class} the template is defined for
 */
export const template = html `
  <div class="container">
    <slot name="header" part="header">${defaultHeader}</slot>
    <entity-list
      title=${(x) => x.title}
      async-add=${(x) => x.asyncAdd}
      async-remove=${(x) => x.asyncRemove}
      async-update=${(x) => x.asyncUpdate}
      enable-cell-flashing=${(x) => x.enableCellFlashing}
      enable-row-flashing=${(x) => x.enableRowFlashing}
      persist-column-state-key=${(x) => x.persistColumnStateKey}
      size-columns-to-fit=${(x) => x.sizeColumnsToFit}
      enable-filter-bar=${(x) => x.enableFilterBar}
      resourceName=${(x) => x.resourceName}
      :deleteEvent=${(x) => x.deleteEvent}
      :updateEvent=${(x) => x.updateEvent}
      :gridOptions=${(x) => x.gridOptions}
      :columns=${(x) => x.columns}
      :datasourceConfig=${(x) => x.datasourceConfig}
      data-test-id="entity-list"
      hide-edit=${(x) => x.hideEdit}
      hide-delete=${(x) => x.hideDelete}
    >
      <slot name="header" slot="header">${defaultHeader}</slot>
    </entity-list>
    <zero-modal
      ${ref('editEntityModal')}
      position=${(x) => x.modalPosition}
      :onCloseCallback=${(x) => x.closeModal.bind(x)}
      data-test-id="edit-entity-modal"
    >
      <div slot="top" data-test-id="dialog-title">${(x) => x.editDialogTitle}</div>

      <slot name="edit">
        ${when((x) => x.editModalVisible, html `
            <foundation-form
              part="form"
              :renderers=${(x) => x.formRenderers}
              resourceName=${(x) => x.formResourceName}
              :data=${(x) => x.editedEntity}
              :uischema=${(x) => x.formUiSchema}
              readonly=${(x) => x.readonly}
              @submit-success=${(x, c) => x.submitEntityChanges(c.event)}
            ></foundation-form>
          `)}
      </slot>
    </zero-modal>
  </div>
`;
